import { DataCard } from '@/components/DataCard/DataCard'
import { FormCheckboxField, FormReadonlyField } from '@/components/Form/FormField'
import { useFormikContext } from 'formik'

interface AccountGroupDetailsFormValues {
  tradingAccountGroupType?: string
  accountGroupType?: string
  bookType?: string
  classification?: string
  currency?: string
  country?: string
  isEnabled?: boolean
  isSwapFree?: boolean
  canBeAttached?: boolean
  canBeDirectAssigned?: boolean
  canBeIBAssigned?: boolean
}

export const AccountGroupDetailsBlock = (): JSX.Element => {
  const { values } = useFormikContext<AccountGroupDetailsFormValues>()

  return (
    <DataCard columns={2} title='Account Group Details'>
      <FormReadonlyField
        label='Trading Account Type'
        name='tradingAccountGroupType'
        value={values.tradingAccountGroupType}
        dataTest='trading-account-type-field'
      />
      <FormReadonlyField
        label='Account Group Type'
        name='accountGroupType'
        value={values.accountGroupType}
        dataTest='account-group-field'
      />
      <FormReadonlyField
        label='Book'
        name='bookType'
        value={values.bookType}
        dataTest='book-field'
      />
      <FormReadonlyField
        label='Classification'
        name='classification'
        value={values.classification}
        dataTest='classification-field'
      />
      <FormReadonlyField
        label='Currency'
        name='currency'
        value={values.currency}
        dataTest='currency-field'
      />
      <FormReadonlyField
        label='Country'
        name='country'
        value={values.country}
        dataTest='country-field'
      />
      <FormCheckboxField
        readOnly
        label='Enabled'
        name='isEnabled'
        value={values.isEnabled}
        dataTest='trading-account-enabled-field'
      />
      <FormCheckboxField
        readOnly
        label='Swap Free'
        name='isSwapFree'
        value={values.isSwapFree}
        dataTest='trading-account-swap-free-field'
      />
      <FormCheckboxField
        readOnly
        label='Can be attached'
        name='canBeAttached'
        value={values.canBeAttached}
        dataTest='trading-account-can-be-attached-field'
      />
      <FormCheckboxField
        readOnly
        label='Can be direct assigned'
        name='canBeDirectAssigned'
        value={values.canBeDirectAssigned}
        dataTest='trading-account-can-be-direct-assigned-field'
      />
      <FormCheckboxField
        readOnly
        label='Can be IB assigned'
        name='canBeIBAssigned'
        value={values.canBeIBAssigned}
        dataTest='trading-account-can-be-ib-assigned-field'
      />
    </DataCard>
  )
}
